import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { tr } from 'i18n';
import InterfacePreferences from 'localization/InterfacePreferences'
import { useAuth } from 'hooks/useAuth'
import { useEffect, useState } from 'react'
import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import stylesB from './Layout.module.scss'
import stylesW from './LayoutW.module.scss'
import userInfo from 'utils/userInfo'
import Popup from './component/Popup'

// ПОПАП
function Layout({ children }) {
  useInterfaceLanguage();
  // попап

  const [popup, setPopup] = useState(null);
  const [popup_status, setPopupStatus] = useState(null);

  const closePopup = () => {
    setPopup(null);
  };

  const handleMouseDown = (event) => {

    if (event.button === 2) {
      event.preventDefault();
      setPopupStatus("in")
      const { clientX, clientY } = event;
      setPopup({ x: clientX, y: clientY });
    }


  };

  // попап
  const [lastTouchTime, setLastTouchTime] = useState(0);

  const handleTouchStart = (event) => {
    const now = Date.now();
    const timeDiff = now - lastTouchTime;
    if (timeDiff < 300) {
      setPopupStatus("in")
      const { clientX, clientY  } = event.touches[0];
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const thirtyPercent = screenWidth * 0.1
      const thirtyPercentHeight = screenHeight * 0.1;
      const side = clientX < screenWidth / 2 ? 'left' : 'right';
      const top = clientY < screenHeight / 2 ? 'top' : 'bottom';

      let x = clientX;
      let y = clientY;
      if (side === 'right') {
        x = (screenWidth / 2) - thirtyPercent;
      } else {

        x = clientX;
      }
      if (top === 'bottom') {
        y = (screenHeight / 2) - thirtyPercentHeight;
      }
      setTimeout(() => {
        setPopup({ x, y });
      }, 500);

    }
    setLastTouchTime(now);
  };
  const handleTouchMove = () => {
    setPopup(null);
  };
  useEffect(() => {
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: false })
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, [lastTouchTime]);



  useEffect(() => {

    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };

  }, []);

  // states

  const { isAuth } = useAuth()
  const user = userInfo()
  const [width, setWidth] = useState(window.innerWidth)
  const [render, setRender] = useState(false)
  const [styles, setThem] = useState(stylesB)

  const [backgroundImage, setBackgroundImage] = useState(
    localStorage.getItem('background'),
  )

  // functions
  useEffect(() => {
    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
    setRender(true)
    function handleResize() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [width])

  return (
    <div className="erp-legacy">
      <InterfacePreferences placement="legacy" />
      {width >= 769 ? <Sidebar /> : null}

      <div
        className={styles.layout__wrapper}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          objectFit: 'cover',
        }}
      >
        <div className={styles.body__wrapper} id="laylayoutout">
          <Header width={width} setBackgroundImage={setBackgroundImage} />
          <div className={styles.child__wrapper}>{children}</div>
          {/* попап */}
          {tr(popup && <Popup x={popup.x} y={popup.y} closePopup={closePopup} />)}
          {/* попап */}
        </div>
      </div>

      <div
        className={styles.layout__wrapper2}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          objectFit: 'cover',
        }}
      >

        <Header width={width} setBackgroundImage={setBackgroundImage} />
        <div className={styles.body__wrapper}>

          <div className={styles.child__wrapper}>{children}</div>
          {/* попап */}
          {tr(popup && <Popup x={popup.x} y={popup.y} closePopup={closePopup} />)}
          {/* попап */}
        </div>
      </div>
    </div>
  )
}

export default Layout
